// src/hooks/useFetchItems.ts
import { useState, useEffect } from 'react';
import config from '../config';
import { PurchaseType } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

const useFetchPurchaseTypes = () => {
  const [apiResponse, setApiResponse] = useState<PurchaseType[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/purchase/type`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        setApiResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };

    fetchItems();
  }, [sessionState]);

  return { apiResponse, error };
};

export default useFetchPurchaseTypes;
